export const aggregationsResolver = {
  JobAggregationResult: () => ({
    employmentTypes: [
      {
        id: 'FULL_TIME.ef2fe9',
        count: 221,
        employmentType: {
          localizationValue: 'Full-time',
        },
      },
      {
        id: 'PART_TIME.58889d',
        count: 15,
        employmentType: {
          localizationValue: 'Part-time',
        },
      },
    ],
    disciplines: [
      {
        id: '1008.61ee6f',
        count: 12,
        discipline: {
          localizationValue: 'Health, medical and social',
        },
      },
    ],
  }),
};

export const filterCollectionResolver = {
  JobSearchQueryBody: () => ({
    filterCollection: [
      {
        __typename: 'JobFilterEmploymentType',
        entityId: 'FULL_TIME.ef2fe9',
        employmentType: {
          localizationValue: 'Full-time',
        },
      },
    ],
  }),
};

export const searchQueryBodyResolver = {
  JobSearchQueryBody: () => ({
    keywords: 'QA',
    location: {
      city: {
        id: '123.abc',
        name: 'Hamburg',
      },
      radius: 20,
    },
    filterCollection: [
      {
        __typename: 'JobFilterEmploymentType',
        entityId: 'FULL_TIME.ef2fe9',
        employmentType: {
          localizationValue: 'Full-time',
        },
      },
      {
        __typename: 'JobFilterSalary',
        min: 20000,
        max: 50000,
      },
      {
        __typename: 'JobFilterCompany',
        entityId: '8.1fb990',
      },
      {
        __typename: 'JobFilterCompany',
        entityId: '9.1fb990',
      },
    ],
  }),
};

const baseResolver = ({ includeMatchingHighlights = false } = {}) => ({
  JobSearchResult: () => ({
    collection: [
      {
        trackingToken: 'tracking-token-0',
        position: 0,
        jobDetail: {
          __typename: 'VisibleJob',
          id: '123.123',
          title: 'Senior Machine Learning Expert',
          salary: { __typename: 'SalaryRange', minimum: 45000, maximum: 65000, currency: 'EUR' },
          slug: 'senior-machine-learning-expert',
          userInteractions: {
            bookmark: {
              state: 'NOT_BOOKMARKED',
            },
          },
        },
        matchingHighlightsV2: includeMatchingHighlights
          ? {
              token: '',
              highlight: {
                type: 'job_highlight_type',
                localization: {
                  localizationValue: 'Highlight',
                },
                localizationA11y: {
                  localizationValue: 'Highlight',
                },
              },
              matchingFacts: [
                {
                  __typename: 'JobMatchingHighlightsJobKeyfactStringV2',
                  type: 'job_keyfact_employment_type',
                  localization: { localizationValue: 'Matching fact' },
                  localizationA11y: { localizationValue: 'Matching fac' },
                },
              ],
              nonMatchingFacts: [
                {
                  __typename: 'JobMatchingHighlightsJobKeyfactStringV2',
                  type: 'job_keyfact_employment_type',
                  localization: { localizationValue: 'NonMatching fact' },
                  localizationA11y: { localizationValue: 'NonMatching fact' },
                },
              ],
            }
          : null,
      },
      {
        trackingToken: 'tracking-token-1',
        position: 1,
        jobDetail: {
          __typename: 'VisibleJob',
          id: '234.234',
          title: 'QA Engineer',
          slug: 'qa-engineer',
          userInteractions: {
            bookmark: {
              state: 'SAVED',
            },
          },
        },
        matchingHighlightsV2: includeMatchingHighlights
          ? {
              token: '',
              highlight: {
                type: 'job_highlight_type',
                localization: {
                  localizationValue: 'Highlight',
                },
                localizationA11y: {
                  localizationValue: 'Highlight',
                },
              },
              matchingFacts: [
                {
                  __typename: 'JobMatchingHighlightsJobKeyfactStringV2',
                  type: 'job_keyfact_employment_type',
                  localization: { localizationValue: 'Matching fact' },
                  localizationA11y: { localizationValue: 'Matching fac' },
                },
              ],
              nonMatchingFacts: [
                {
                  __typename: 'JobMatchingHighlightsJobKeyfactStringV2',
                  type: 'job_keyfact_employment_type',
                  localization: { localizationValue: 'NonMatching fact' },
                  localizationA11y: { localizationValue: 'NonMatching fact' },
                },
              ],
            }
          : undefined,
      },
    ],
    total: 250,
    searchQuery: { guid: 'query-id' },
  }),
});

export const resultsResolver = baseResolver();

export const resultsMatchingHighlightsV2Resolver = baseResolver({
  includeMatchingHighlights: true,
});

export const bigTotalResultsResolver = {
  JobSearchResult: () => ({
    total: 1000000,
  }),
};

export const noResultsResolver = {
  JobSearchResult: () => ({
    collection: [],
    total: 0,
  }),
};
